import { render, staticRenderFns } from "./LeaveTypes.vue?vue&type=template&id=612173ef&scoped=true&"
import script from "./LeaveTypes.vue?vue&type=script&lang=js&"
export * from "./LeaveTypes.vue?vue&type=script&lang=js&"
import style0 from "./LeaveTypes.vue?vue&type=style&index=0&id=612173ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612173ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('612173ef')) {
      api.createRecord('612173ef', component.options)
    } else {
      api.reload('612173ef', component.options)
    }
    module.hot.accept("./LeaveTypes.vue?vue&type=template&id=612173ef&scoped=true&", function () {
      api.rerender('612173ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hrmanagement/LeaveManagement/LeaveTypes.vue"
export default component.exports